const composeMixins = (...mixins) => (Base) => mixins.reduce((acc, mixin) => mixin(acc), Base)

export {
  composeMixins,
}
